<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd10">
      <div id="search-market" class="search-market">
        <h3>{{'Market'|translate}}</h3>
        <div class="row">
          <div class="col-md-4">
            <div class="search-controls mb20">
              <p class="mobile-search-toggle visible-xs" v-on:click="hide_mobile = !hide_mobile">
                {{'Search'|translate}}
                <i class="fas fa-angle-down" v-if="hide_mobile"></i>
                <i class="fas fa-angle-up" v-if="!hide_mobile"></i>
              </p>
              <div class="panel panel-default" v-bind:class="{'hidden-xs':hide_mobile}">
                <div class="panel-heading">
                  <p class="all-types">
                    <a
                      v-for="(item) in types"
                      :key="item.id"
                      v-bind:class="{active:search_params.type_id == item.id}"
                      v-on:click="changeType(item.id)"
                    >{{ item.name }}</a>
                  </p>
                </div>
                <div class="panel-body">
                  <form v-on:submit.prevent="formDoSearch">
                    <div class="row">
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <select class="form-control" v-model="search_params.product_id">
                            <option value>{{'All products'|translate}}...</option>
                            <option
                              v-for="item in allProducts"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <select
                            class="form-control"
                            v-model="search_params.province_id"
                            @change="onSelectProvince"
                          >
                            <option value>{{'All provinces'|translate}}...</option>
                            <option
                              v-for="item in list_provinces"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <select
                            class="form-control"
                            v-model="search_params.district_id"
                            @change="onSelectDistrict"
                          >
                            <option value>{{'All districts'|translate}}...</option>
                            <option
                              v-for="item in list_districts"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <select class="form-control" v-model="search_params.commune_id">
                            <option value>{{'All communes'|translate}}...</option>
                            <option
                              v-for="item in list_communes"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-12 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <select class="form-control" v-model="search_params.unit_price">
                            <option value>{{'All unit prices (price_unit)'|translate}}...</option>
                            <option
                              v-for="item in unit_prices"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-12 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <select class="form-control" v-model="search_params.quantity">
                            <option value>{{'All quantity (kg)'|translate}}...</option>
                            <option
                              v-for="item in kgs"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-12">
                        <div class="input-group wrap-query">
                          <input
                            type="text"
                            placeholder="Từ khóa"
                            v-model="search_params.keyword"
                            class="search-query form-control"
                          />
                          <span class="input-group-btn">
                            <button type="button" class="btn btn-danger transparent">
                              <span class="glyphicon glyphicon-search"></span>
                            </button>
                          </span>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 mt10" v-if="user">
                        <input type="checkbox" id="search-my-post" v-model="search_params.my_post" />
                        <label
                          class="no-bold"
                          for="search-my-post"
                        >{{ 'Search my post' |translate }}</label>
                      </div>
                      <div class="col-md-12 col-xs-12 mt10">
                        <button type="submit" class="btn btn-success full-width">
                          <i class="fas fa-search"></i>
                          {{'Search'|translate}}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- end search controls -->
          </div>
          <div class="col-md-8">
            <!-- <p class="alert alert-info" v-if="!user">{{'You need login to post ad here'|translate}}</p> -->
            <insert-market
              
              :user="user"
              :types="types"
              :allProducts="allProducts"
              :list_payments="list_payments"
              @refresh="doSearch"
            ></insert-market>
            <loading class="mt10" :text="'Please wait'|translate" v-if="list_items ===null"></loading>
            <p
              class="mt10 alert alert-warning"
              v-if="list_items && list_items.length == 0"
            >{{'No result'|translate}}</p>

            <div v-if="list_items && list_items.length >0" class="list-results">
              <div class="item" v-for="item in list_items" :key="item.id">
                <div class="top">
                  <div class="poster">
                    <div class="avatar">
                      <img v-if="item['user_feature_image']" :src="item.user_feature_image" />
                      <img v-if="!item['user_feature_image']" src="/static/images/avatar.jpg" />
                    </div>
                  </div>
                  <div class="title">
                    <router-link
                      :to="{ name: 'Profile', params: { profileId: item.user_unique_code }}"
                    >{{item.user_fullname}}</router-link>
                  </div>
                  <div class="bottom-title">
                    <span class="time">{{ item.add_date | moment("from", "now") }}</span>
                    <span
                      class="mytag"
                      v-bind:class="{buy:item.type_id == 1,sell:item.type_id == 2}"
                    >{{mapTypes[item.type_id]}} {{mapProducts[item.product_id]}}</span>
                  </div>
                  <div class="wrap-dropdown">
                    <mydropdown :ref="item.refDropdown">
                      <div slot="button">
                        <span
                          class="dropdown-toggle"
                          data-toggle="dropdown"
                          v-on:click="$refs[item.refDropdown][0].toogle()"
                        >
                          <i class="fas fa-ellipsis-h fa-lg"></i>
                        </span>
                      </div>
                      <ul slot="body" class="dropdown-menu dropdown-menu-right">
                        <li v-on:click="copyLink(item)">
                          <a>
                            <i class="far fa-copy"></i>
                            {{'Copy link'|translate}}
                          </a>
                        </li>
                        <li v-if="user && user.id == item.user_id">
                          <a v-on:click="updateItem(item)">
                            <i class="fas fa-edit"></i>
                            {{'Update'|translate}}
                          </a>
                        </li>
                        <li v-if="user && user.id == item.user_id">
                          <a v-on:click="removeAd(item)">
                            <i class="fas fa-times"></i>
                            {{'Remove'|translate}}
                          </a>
                        </li>
                      </ul>
                    </mydropdown>
                  </div>
                </div>
                <div class="bone">
                  <div class="content">
                    <p class="summary">
                      <span>{{'Quantity (kg)'|translate}}:</span>
                      {{toCommas(item.quantity)}}
                      <br />
                      <span>{{'Unit price (unit_price)/kg'|translate}}:</span>
                      {{toCommas(item.unit_price)}}
                      <br />
                      <span>{{'Payment methods'|translate}}:</span>
                      {{mapPayments[item.payment_method]}}
                      <br />
                      <span>{{'Total price (unit_price)'|translate}}:</span>
                      {{toCommas(item.total_price)}}
                      <br />
                      <span>{{'Location'|translate}}:</span>
                      {{item.commune_name}}, {{item.district_name}}, {{item.province_name}}
                      <br />
                    </p>
                    <p class="quote" v-html="item.description"></p>
                  </div>
                  <!-- have-2 -->
                  <div
                    class="media"
                    v-bind:class="{plural:item.images.length > 1, have2:item.images.length ==2}"
                  >
                    <div class="list-media">
                      <a
                        v-for="(photo, photoIndex) in item.images"
                        :key="photoIndex"
                        @click="clickPhoto(item,photoIndex)"
                      >
                        <img :src="photo.url_thumb" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end item  -->
            </div>
          </div>
        </div>
      </div>
      <!-- end search-market -->
    </div>
    <gallery v-if="photos" :images="photos" :index="index" @close="index = null"></gallery>
    <edit-market
      v-if="edit_item"
      :list_payments="list_payments"
      :user="user"
      :item="edit_item"
      :types="types"
      :allProducts="allProducts"
      @refresh="doSearch"
      ref="editmarket"
    ></edit-market>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Paginate from "vuejs-paginate";
import Loading from "@/components/elements/Loading";
import InsertMarket from "@/components/elements/InsertMarket";
import EditMarket from "@/components/elements/EditMarket";
import gallery from "vue-gallery";
import mydropdown from "vue2-bootstrap-dropdown";
export default {
  name: "FindLand",
  components: {
    mydropdown,
    MyHeader,
    Paginate,
    Loading,
    gallery,
    InsertMarket,
    EditMarket
  },
  data() {
    let data = {
      photos: [],
      index: null,
      user: null,
      hide_mobile: true,
      list_items: null,
      page: 1,
      edit_item: null,
      working: false,
      total_page: 1,
      allProducts: [],
      mapProducts: {},
      list_provinces: [],
      list_districts: [],
      list_communes: [],
      list_payments: [
        { id: "1", name: this.$t("Pre Transfer") },
        { id: "2", name: this.$t("Receive and transfer") },
        { id: "3", name: this.$t("Via vehicle") }
      ],
      types: [
        { id: "", name: this.$t("All") },
        { id: "1", name: this.$t("Buy") },
        { id: "2", name: this.$t("Sell") }
      ],
      unit_prices: [
        { id: "<5000", name: this.$t("Under") + " 5,000" },
        { id: "<10000", name: this.$t("Under") + " 10,000" },
        { id: "<50000", name: this.$t("Under") + " 50,000" },
        { id: "<100000", name: this.$t("Under") + " 100,000" },
        { id: "<500000", name: this.$t("Under") + " 500,000" },
        { id: "<1000000", name: this.$t("Under") + " 1000,000" },
        { id: ">1000000", name: this.$t("Over") + " 1000,000" }
      ],
      kgs: [
        { id: "<50", name: this.$t("Under") + " 50" },
        { id: "<100", name: this.$t("Under") + " 100" },
        { id: "<500", name: this.$t("Under") + " 500" },
        { id: "<1000", name: this.$t("Under") + " 1,000" },
        { id: "<5000", name: this.$t("Under") + " 5,000" },
        { id: ">5000", name: this.$t("Over") + " 5,000" }
      ],
      search_params: {
        type_id: "",
        keyword: "",
        product_id: "",
        limit: Utils.getLimit(),
        province_id: "",
        district_id: "",
        commune_id: "",
        unit_price: "",
        offset: 0,
        quantity: "",
        my_post: false
      }
    };
    data.mapTypes = Utils.arrayToObject(data.types);
    data.mapPayments = Utils.arrayToObject(data.list_payments);
    return data;
  },
  watch: {
    $route(to, from) {
      console.log("from", from, "to", to);
      this.doSearch();
    }
  },
  methods: {
    updateItem(item) {
      this.edit_item = null;
      setTimeout(() => {
        this.edit_item = item;
        setTimeout(() => {
          this.$refs.editmarket.open();
        }, 10);
      }, 10);
    },
    removeAd(ad) {
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        this.$t("Are you sure to remove this ad ?"),
        () => {
          Utils.request(this, true, "market")
            .delete(`/manage/${ad.id}`)
            .then(response => {
              this.doSearch();
            });
        }
      );
    },
    show(ref) {
      console.log(ref[0].toogle());
    },
    clickPhoto(item, photoIndex) {
      this.photos = item.images.map(item => {
        return item.url_medium;
      });
      this.index = photoIndex;
    },
    changeType(type_id) {
      this.search_params.type_id = type_id;
      this.doSearch();
    },
    getProvines() {
      Utils.getProvinces(this).then(data => {
        this.list_provinces = data.list;
      });
    },
    copyLink(item) {
      let str = Utils.getBaseUrl() + "/market/" + item.id;
      Utils.sendToClipboard(str);
      this.$alertify.success(this.$t("Copied link"));
    },
    onSelectProvince(e) {
      e.preventDefault();

      this.getDistricts();
    },
    getDistricts() {
      this.list_districts = [];
      this.list_communes = [];

      this.search_params.district_id = "";
      this.search_params.commune_id = "";
      if (this.search_params.province_id) {
        this.getListDistricts();
      }
    },
    getListDistricts() {
      Utils.request(this, true, "landmarket")
        .get(`/listDistricts/${this.search_params.province_id}`)
        .then(response => {
          this.list_districts = response.data.data.list;
          //console.log('this.list_districts',this.list_districts)
        });
    },
    onSelectDistrict() {
      console.log("on change district", this.search_params.district_id);
      this.getCommunes();
    },
    getCommunes() {
      this.list_communes = [];
      this.search_params.commune_id = "";
      if (this.search_params.district_id) {
        this.getListCommune();
      }
    },
    getListCommune() {
      Utils.request(this, true, "landmarket")
        .get(`/listCommunes/${this.search_params.district_id}`)
        .then(response => {
          this.list_communes = response.data.data.list;
        });
    },
    formDoSearch() {
      if ("MarketDetail" == this.$route.name) {
        this.$router.push({ name: "Market" });
      } else {
        this.doSearch();
      }
    },
    doSearch() {
      this.edit_item = null;
      this.search_params.offset = 0;
      this.page = 1;
      this.search_params.id = "";
      this.search();
    },
    search(isLoadMore = false) {
      this.working = true;
      if (!isLoadMore) {
        this.list_items = null;
      }

      Utils.request(this, true, "market")
        .get(`/search/?${Utils.arrayToRequestParam(this.search_params)}`)
        .then(response => {
          let data = response.data;
          this.working = false;
          if (data.status === "ok") {
            let list = data.data.list;
            list = list.map(item => {
              let temp = new Date(parseInt(item.add_time) * 1000);
              item.add_date = this.$moment(temp);
              item.total_price = item.quantity * item.unit_price;
              item.refDropdown = "dropdown" + item.id;
              //set as medium for case only image is added
              if (item.images.length == 1) {
                item.images[0].url_thumb = item.images[0].url_medium;
              }
              if (item.lat) {
                item.location = [parseFloat(item.lat), parseFloat(item.lng)];
              }
              return item;
            });
            if (!isLoadMore) {
              this.list_items = list;
            } else {
              this.list_items = this.list_items.concat(list);
            }

            this.total_page = Utils.getTotalPages(data.data.total);
          }
        })
        .catch(error => {
          this.working = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    toCommas(value) {
      return Utils.toCommas(value);
    },
    getAllProducts() {
      Utils.getAllProducts(this, {}).then(data => {
        this.allProducts = data;
        this.mapProducts = Utils.arrayToObject(this.allProducts);
      });
    },
    pageScroll(event) {
      //console.log('event',event.target.offsetHeight, event.target.scrollTop)
      if (this.working || this.total_page <= this.page) {
        return;
      }
      if (
        event.target.offsetHeight + event.target.scrollTop >
        this.el.offsetHeight
      ) {
        // console.log('load more');
        this.page++;
        this.search_params.offset = Utils.getNextOffset(this.page);
        this.search(true);
      } else {
        //console.log('no need');
      }
    }
  },
  mounted() {
    this.user = Utils.getUser(this);
    if (this.$route.params.id) {
      this.search_params.id = this.$route.params.id;
    }

    this.search();
    this.getProvines();
    this.getAllProducts();
    let app = document.getElementById("main");
    this.el = document.getElementById("search-market");
    app.addEventListener("scroll", this.pageScroll);
  },
  beforeDestroy() {
    let app = document.getElementById("main");
    app.removeEventListener("scroll", this.pageScroll);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ProductMarket.vue